export default __webpack_public_path__ + "static/media/banner12.963994d8.svg";